export default __webpack_public_path__ + "static/media/slide-3.eae1d189.jpg";